<template>
  <div id="userSingle" class="viewport">
  
  
      <div class="columns">
        <div class="column">
          <h1>User {{user.usernm}}</h1>
        </div>
        <div class="column alignRight">
          <button class="button buttonSave is-pulled-right" v-on:click="userSave">Speichern</button>
          <router-link tag="button" class="button is-pulled-right" :to="{ name: 'Users' }">Zurück</router-link>
        </div>
      </div>

  
    <div class="userkeyfacts">
      <div class="columns">
        <div class="column">
          <div class="borderround">
            <h2>Key Facts</h2>
            <div class="user_name"><input v-model="user.usernm"><label>Username</label></div>
            <div class="user_email"><input v-model="user.maildrss"><label>E-Mail-Adresse</label></div>
            <div class="user_password"><input v-model="user.passwrd" type="password"><label>Passwort</label></div>
            <div class="user_role">            
                <select v-model="user.role">
                  <option value="" :selected="user.role == ''">...auswählen</option>
                  <option value="admin" :selected="user.role == 'admin'">Admin</option>
                  <option value="ankauf" :selected="user.role == 'ankauf'">Ankauf</option>
                  <option value="verkauf" :selected="user.role == 'verkauf'">Verkauf</option>
                  <option value="dispo" :selected="user.role == 'dispo'">Dispo</option>
                  <option value="fahrer" :selected="user.role == 'fahrer'">Fahrer</option>
                  <option value="dat" :selected="user.role == 'dat'">DAT</option>
                  <option value="city manager" :selected="user.role == 'citymanager'">City Manager</option>
                </select>
                <label>User role</label>            
            </div>  
            <div class="user_acitve">            
              <input v-model="user.active_user" type="checkbox" :checked="user.active_user == 1"> Aktiv
            </div>
          </div>
        </div>
        <div class="column">

          <div class="borderround">          
            <h2>Nutzer-Rechte</h2>
            <ul>
              <li><input type="checkbox" id="edit_inbox" value="edit_inbox" v-model="user_rights"> Eingang</li>
              <li><input type="checkbox" id="edit_dat" value="edit_dat" v-model="user_rights"> DAT</li>
              <li><input type="checkbox" id="edit_users" value="edit_users" v-model="user_rights"> Nutzer</li>
              <li><input type="checkbox" id="edit_websites" value="edit_websites" v-model="user_rights"> Websites</li>
              <li><input type="checkbox" id="edit_cities" value="edit_cities" v-model="user_rights"> Cities</li>
            </ul>
          </div>
        </div>
      </div>
    </div>  
    
    <div class="buttonbox">
    </div>
  </div>
</template>
<script>
export default {
  name: "UserSingle",  
  props: ['userid'],
  data() {
      return {
            user: { usernm: "", maildrss:"", role:"", custom_settings:"" , active_user: false, user_rights: this.user_rights },
            user_rights: [],
            buttonText: 'Speichern'
        }
  },
  watch: {
    'user.usernm' : {
          handler: function(val, oldVal){ console.log('user changed from '+oldVal+' to ' + val); $('.buttonSave','#userSingle').text(this.buttonText); }
        },
    'user.maildrss' : {
          handler: function(val, oldVal){ console.log('user changed'); $('.buttonSave','#userSingle').text(this.buttonText); }
        },
    'user.role' : {
          handler: function(val, oldVal){ console.log('user changed'); $('.buttonSave','#userSingle').text(this.buttonText); }
        },
    'user.active_user' : {
          handler: function(val, oldVal){ console.log('user changed'); $('.buttonSave','#userSingle').text(this.buttonText); }
        },
    'user_rights': {
          handler: function(val, oldVal){ console.log('user_rights changed'); this.user.user_rights = this.user_rights; $('.buttonSave','#userSingle').text(this.buttonText); }      
    },
    deep: true
  },
  sockets: {
    getUsersByID(r){
      //console.log('got user')
      //console.log(r)
      this.user = r 
      this.user_rights = JSON.parse(r.user_rights)
    },
    
    userSaved(r){
      
      var $this = this;
      
      //console.log('user saved');
      //console.log(r);
      
      if(r.success == true )
      setTimeout( function(){ $('.buttonSave','#userSingle').html('<i class="fa fa-check"></i>') },1000);
    },
    
    
    
  },
  methods: {
    userSaveValue(user, field, value){
      this.$socket.emit('userSaveValue', { update: { id: user.id, field: field, value: value, oldValue: this.oldValue }, quiet: 0 } );
    },
    
    userSave(e) {
      $(e.currentTarget).html('<i class="fa fa-spinner fa-pulse"></i>');
      //console.log('userSave');
      var user = this.user
          user.user_rights = this.user_rights;
          
      this.$socket.emit('userSave', { update: { user: user }, quiet: 0 } );            
    },
    
  },
  mounted: function(){
    console.log('userSingle mounted')
    
    if( this.userid == "new" )
    this.user.id = 'new'
    else    
    this.$socket.emit('getUsersByID', { userid: this.userid });
  },
  created: function(){
    console.log('id: ' + this.userid);
    console.log(this);
  },  
  

  
}  
</script>